import React            from "react";
import PropTypes        from "prop-types";
import Flux             from "../../flux/Flux";
import Grid2            from "../Grid2/Grid2";
import withStaticLoader from "../HigherOrderComponents/Utility/withStaticLoader";
import withTVSeries     from "../HigherOrderComponents/TV/withTVSeries";
import TVSeriesTile     from "../Grid2/Tiles/TVSeriesTile";
import Grid2Helper      from "../../utils/Grid2Helper";
import withWindowWidth  from "../HigherOrderComponents/Utility/withWindowWidth";

class TVSeriesGrid extends React.PureComponent {
	constructor(props) {
		super(props);
	}

	render() {
		if (!this.props.series) {
			return null;
		}

		let series = [...this.props.series];

		const columns = {xs: 2, sm: 3, md: 3, lg: 5};

		if (!this.props.isMobile) {
			const videoLength = Grid2Helper.getItemCountForFullRows(columns, Grid2Helper.getBreakpointByWindowWidth(this.props.windowWidth), series.length);

			if (videoLength) {
				series = series.splice(0, videoLength);
			}
		}

		return (
			<Grid2 tileData={series}
			       defaultTileClass={TVSeriesTile}
			       columns={columns}
			       tileClasses={[{index: 0, tileClass: TVSeriesTile}]}
			       slider={this.props.isMobile}
			       tilePadding={Flux.Constants.Grid2.TilePadding.SMALL}
				   lazyImageLoading={this.props.lazyImageLoading}
			/>
		);
	}
}

TVSeriesGrid.propTypes = {
	series:           PropTypes.array,
	isMobile:         PropTypes.bool.isRequired,
	windowWidth:      PropTypes.number.isRequired,
	lazyImageLoading: PropTypes.bool,
};

TVSeriesGrid.defaultProps = {
	series:		      [],
	isMobile:         false,
	lazyImageLoading: false,
};


export default withWindowWidth(withTVSeries(withStaticLoader(TVSeriesGrid)));
